<template>
  <div class="columns">
    <div class="column is-2-desktop is-2-tablet is-3-mobile">
      <a class="logo-link" href="https://2290Tax.com">
        <img src="\2290taxlogo.png" width="166" height="105">
      </a>
    </div>
    <div class="column">
      <div class="columns">
        <div class="column navbar-line1 navbar-heading ">Admin Portal</div>
        <div class="navbar-item">
          <LoginModal v-on:signIn="userLoggedIn"></LoginModal>
        </div>
      </div>
      <nav class="navbar" role="navigation" aria-label="main navigation">
          <div class="navbar-brand">
            <a role="button" class="navbar-burger" aria-label="menu"
              aria-expanded="false" data-target="2290BillingNavBar"
              onclick="document.querySelector('.navbar-menu').classList.toggle('is-active');">
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
          </div>

          <div id="2290BillingNavBar" class="navbar-menu">
            <div class="navbar-start">
              <router-link to="/exception-report" class="menu-button">
                Exception Report
              </router-link>
              <router-link to="/current-billing" class="menu-button">
                Current Billing Cycle
              </router-link>
              <router-link to="/past-billings" class="menu-button">
                Past Billing Cycles
              </router-link>
              <!-- <router-link to="/invoices-and-receipts" class="menu-button">
                Invoices &amp; Receipts
              </router-link> -->
              <router-link to="/customers" class="menu-button">
                Customers
              </router-link>
              <router-link to="/users" class="menu-button" v-if="showAdminFeatures">
                Pool Users
              </router-link>
            </div>

            <div class="navbar-end">
            </div>
          </div>
      </nav>

    </div>
  </div>
</template>

<script>
import LoginModal from '@/components/login-modal.vue';
import { Auth } from 'aws-amplify';

export default {
  name: 'HeaderBar',
  components: {
    LoginModal,
  },
  data() {
    return {
      showAdminFeatures: false,
    };
  },
  computed: {},
  methods: {
    async userLoggedIn() {
      const currentUser = await Auth.currentAuthenticatedUser();
      // console.log('The current user is...');
      // console.log(currentUser);
      const groups = currentUser.signInUserSession.accessToken.payload['cognito:groups'];
      console.log(groups);
      if (groups && (groups.includes('billing-admin-it-admin'))) {
        this.showAdminFeatures = true;
      } else {
        this.showAdminFeatures = false;
      }
    },
  },
  async created() {
    await this.userLoggedIn();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logo-link {
    margin-left: 10px;
  }
  .menu-button {
    background-image: linear-gradient(#787877,#434342);
    color: #BDBDBD;
    vertical-align: center;
    padding-top: 2px;
    padding-bottom: 0px;
    padding-left: 21px;
    padding-right: 21px;
    margin-left:0px;
    margin-top: 1px;
    margin-right: 0px;
    margin-bottom: 0px;
    height: 30px;
    border: 1px solid #BDBDBD
  }
  .menu-button.router-link-active {
    color:#fff;
    background-color: #000;
    background-image: none;
  }

  .logo-link img {
    margin-left: 120px;
    max-height: 117px;
  }
  .navbar {
    background-color: #333;
    margin-left: 100px;
  }
  .navbar-item {
    color: #fff;
    line-height: 1;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .navbar-burger {
    color: #fff !important;
  }
  .navbar-heading {
    font-family: Impact Regular, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
    font-size: 28px;
    line-height: 37px;
    margin-left: 100px;
  }
  .navbar-line1 {
    color: #fff;
    padding-top: 15px;
    margin-top: 15px;
  }

  @media only screen and (max-width: 1024px) {
    .logo-link img {
      margin-left: 10px;
      max-height: 100px;
    }
    .navbar-heading {
      margin-left: 10px;
    }

    .navbar {
      margin-left: 10px;
    }

    .navbar-button {
      margin-right: 20px;
    }

    .menu-button {
      padding-left: 19px;
      padding-right: 19px;
    }

  }

  @media only screen and (max-width: 812px) {
    .menu-button {
      padding-left: 5px;
      padding-right: 5px;
    }
    .navbar-start {
      margin-left: -120px;
    }

  }

  @media only screen and (max-width: 768px) {
    .menu-button {
      padding-left: 5px;
      padding-right: 5px;
    }
    .navbar-start {
      margin-left: 0px;
    }

  }

</style>
